import {useState} from 'react';
import {Button, Indicator} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {FiFilter} from 'react-icons/fi';
import {FilterDrawer} from '../drawers/FilterDrawer';
import {useReconciliationReportsChannel} from '../hooks/useReconciliationReports';

// FNP-607: standard Filter button + drawer (replaces the inline ChannelSelector), with a
// count Indicator as the active-filter notification (FNP-1891 replaced the sibling
// modules' inline-px absolute Badge with Mantine's Indicator). A channel
// filter is ALWAYS applied here (it defaults to STRIPE and is required, non-clearable),
// so the badge always shows — count is always 1 (the channel). This is the "default
// filter is selected, so show the notification" behaviour the owner asked for.
export const FilterRecordsButton = () => {
    const [opened, setOpened] = useState(false);
    const {channel} = useReconciliationReportsChannel();

    // Exactly one filter is always active (the required channel).
    const activeCount = channel ? 1 : 0;

    return (
        <>
            {/* Mantine Indicator carries the count badge: theme-sized, no inline px. */}
            <Indicator label={activeCount} size={16} disabled={activeCount === 0}>
                <Button
                    variant="outline"
                    leftSection={<FiFilter size={16}/>}
                    onClick={() => setOpened(true)}
                >
                    {I18n.get('Filter')}
                </Button>
            </Indicator>
            <FilterDrawer
                opened={opened}
                onClose={() => setOpened(false)}
            />
        </>
    );
};
